import { fromPalette, fromRole, tintOf, type Theme } from './theme.js';

export const lightTheme: Theme = {
  '--wa-color-surface-lowered': fromPalette('background'),
  '--wa-color-surface-default': fromPalette('container'),
  '--wa-color-surface-raised': fromPalette('container'),
  '--wa-color-surface-border': fromPalette('grey-mid'),

  '--wa-color-text-normal': fromPalette('type'),
  '--wa-color-text-quiet': fromPalette('grey-dark'),
  '--wa-color-text-link': fromPalette('purple'),
  '--wa-color-focus': fromPalette('purple'),

  '--wa-color-brand-fill-quiet': tintOf('purple', 10),
  '--wa-color-brand-fill-normal': tintOf('purple', 20),
  '--wa-color-brand-fill-loud': fromPalette('purple'),
  '--wa-color-brand-border-quiet': tintOf('purple', 20),
  '--wa-color-brand-border-normal': tintOf('purple', 40),
  '--wa-color-brand-border-loud': fromPalette('purple'),
  '--wa-color-brand-on-quiet': fromPalette('purple'),
  '--wa-color-brand-on-normal': fromPalette('purple'),
  '--wa-color-brand-on-loud': fromPalette('white'),

  '--wa-color-neutral-fill-quiet': fromPalette('background'),
  '--wa-color-neutral-fill-normal': fromPalette('grey-mid'),
  '--wa-color-neutral-fill-loud': fromPalette('grey-dark'),
  '--wa-color-neutral-border-quiet': fromPalette('background'),
  '--wa-color-neutral-border-normal': fromPalette('grey-mid'),
  '--wa-color-neutral-border-loud': fromPalette('grey-dark'),
  '--wa-color-neutral-on-quiet': fromPalette('grey-dark'),
  '--wa-color-neutral-on-normal': fromPalette('type'),
  '--wa-color-neutral-on-loud': fromPalette('white'),

  '--wa-color-success-fill-quiet': fromPalette('green'),
  '--wa-color-success-fill-normal': fromPalette('green'),
  '--wa-color-success-fill-loud': fromPalette('green'),
  '--wa-color-success-border-quiet': fromPalette('green'),
  '--wa-color-success-border-normal': fromPalette('green'),
  '--wa-color-success-border-loud': fromPalette('green'),
  '--wa-color-success-on-quiet': fromPalette('type'),
  '--wa-color-success-on-normal': fromPalette('type'),
  '--wa-color-success-on-loud': fromPalette('type'),

  '--wa-color-danger-fill-quiet': tintOf('red', 10),
  '--wa-color-danger-fill-normal': tintOf('red', 20),
  '--wa-color-danger-fill-loud': fromPalette('red'),
  '--wa-color-danger-border-quiet': tintOf('red', 20),
  '--wa-color-danger-border-normal': fromPalette('red'),
  '--wa-color-danger-border-loud': fromPalette('red'),
  '--wa-color-danger-on-quiet': fromPalette('red'),
  '--wa-color-danger-on-normal': fromPalette('red'),
  '--wa-color-danger-on-loud': fromPalette('black'),

  '--wa-color-warning-fill-loud': fromPalette('amber'),
  '--wa-color-warning-border-loud': fromPalette('amber'),
  '--wa-color-warning-on-loud': fromPalette('type'),

  '--wa-form-control-background-color': fromRole('--wa-color-surface-default'),
  '--wa-form-control-value-color': fromRole('--wa-color-text-normal'),
  '--wa-form-control-placeholder-color': fromRole('--wa-color-text-quiet'),
  '--wa-form-control-label-color': fromRole('--wa-color-text-normal'),
  '--wa-form-control-activated-color': fromPalette('green'),

  '--ns-color-disabled-fill': fromPalette('grey-mid'),
  '--ns-color-disabled-text': fromPalette('grey-dark'),
  '--ns-color-control-off': fromPalette('grey-dark'),
  '--ns-color-inverse-surface': fromPalette('type'),
  '--ns-color-inverse-text': fromPalette('white'),
  '--ns-color-inverse-text-quiet': fromPalette('grey-mid'),
  '--ns-color-inverse-link': fromPalette('green'),
  '--ns-color-private-surface': fromPalette('black'),

  // Chart series on the private surface (My Account's Graph card): green and a purple light enough to stand off black. Each
  // series is also named by its legend and the table, so identity never rests on colour alone
  '--ns-color-chart-series-1': fromPalette('green'),
  '--ns-color-chart-series-2': tintOf('purple', 70),

  // The trust score's traffic light: the bright brand fills the status pills use, and a light grey for no score. The fills are
  // too pale to stand out on their own, so the dot has a Type ring: the ring is the 3:1 graphical object
  '--ns-color-score-high': fromPalette('green'),
  '--ns-color-score-mid': fromPalette('amber'),
  '--ns-color-score-low': fromPalette('red'),
  '--ns-color-score-none': fromPalette('grey-mid'),
  '--ns-color-score-ring': fromPalette('type'),
};
